module.exports = __webpack_public_path__ + "static/media/feature_list2.e3512bb9.png";